<script setup lang="ts">
import TextLink from "./TextLink.vue";
</script>

<template>
  <TextLink href="mailto:support@axure.com">support@axure.com</TextLink>
</template>
